export default "__VITE_ASSET__CkIg2rVX__"